import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import SignIn from 'app/auth/containers/sign-in';
import { ERoutesPublic, ERoutesType, routes } from 'types/routes';

const Auth = () => {
    return (
        <Switch>
            <Route path={routes[ERoutesType.Public][ERoutesPublic.SignIn]}>
                <SignIn />
            </Route>
            <Redirect
                to={routes[ERoutesType.Public][ERoutesPublic.SignIn][0]}
            />
        </Switch>
    );
};

export default Auth;
